module.exports = __webpack_public_path__ + "img/choose_pets_450.a8cd5c38.jpg";